import type { EntryPoint } from 'repluggable';

import { A11yWizardStateAPI } from './a11y-wizard-state-api';
import { createA11yWizardStateAPI } from './create-a11y-wizard-state-api';
import type { A11yWizardScopedState } from './store';
import { a11yWizardReducer } from './store';

export const A11yWizardStateAPIEntry: EntryPoint = {
  name: A11yWizardStateAPI.name,

  layer: A11yWizardStateAPI.layer,

  declareAPIs: () => [A11yWizardStateAPI],

  attach: (shell) => {
    shell.contributeState<A11yWizardScopedState>(() => ({
      a11yWizardState: a11yWizardReducer,
    }));
    shell.contributeAPI(A11yWizardStateAPI, () =>
      createA11yWizardStateAPI(shell),
    );
  },
};
